module.exports = __webpack_public_path__ + "img/shamanzs-animation-2.c525a14c.gif";